import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { ROUTES } from "@/constants/routeConstants";
import { getContentGroupDetails } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router";
import { UpdateContentGroupNameInput } from "./UpdateContentGroupNameInput";
import { ContentGroupMembers } from "./ContentGroupMembers";
import { ContentGroupDetailPageHeader } from "./ContentGroupDetailPageHeader";
import { BaseFormLayout } from "../shared/BaseFormLayout";
import { ContentGroupTags } from "./ContentGroupTags";
import { ContentGroupType } from "@/lib/types";

export const ContentGroupDetailPage = () => {
  const { t } = useTranslation();
  const [queryParams] = useSearchParams();
  const contentGroupGuid = queryParams.get("Id");
  const activeFirm = useSelector(selectActiveFirm);

  const contentGroupDetails = useQuery({
    queryKey: ["contentGroupDetails", String(activeFirm?.firmGuid), contentGroupGuid],
    queryFn: () => getContentGroupDetails(String(activeFirm?.firmGuid), String(contentGroupGuid)),
  });

  const contentGroup = contentGroupDetails.data?.data;
  const contentGroupName = contentGroup?.name;

  useBreadcrumbs([
    {
      name: t("entities.contentGroup"),
      path: ROUTES.CONTENT_GROUP,
    },
    {
      name: contentGroupName ? String(contentGroupName) : "...",
      path: ROUTES.CONTENT_GROUP_DETAIL,
      component: contentGroup && <UpdateContentGroupNameInput contentGroup={contentGroup} />,
    },
  ]);

  if (!contentGroupGuid || !contentGroup) {
    return null;
  }

  return (
    <>
      <BaseFormLayout
        title={
          <>
            <div className="mb-2">
              {contentGroupName}{" "}
              {contentGroup.type === ContentGroupType.Robot && (
                <span className="text-muted-foreground text-sm">({contentGroup.typeString})</span>
              )}
            </div>
            <ContentGroupTags contentGroupGuid={contentGroupGuid} contentGroupIntId={contentGroup.intId} />
          </>
        }
        rightContent={<ContentGroupDetailPageHeader contentGroup={contentGroup} />}
      >
        <ContentGroupMembers contentGroup={contentGroup} />
      </BaseFormLayout>
    </>
  );
};
